import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementBlock as _createElementBlock, Teleport as _Teleport, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a055b45"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "container"
}
const _hoisted_2 = { class: "box-container" }
const _hoisted_3 = { class: "row data" }
const _hoisted_4 = ["onKeydown"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Tenant Protection Summary Unavailable", -1))
const _hoisted_6 = ["onKeydown"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "AI Agent Unavailable", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Calls Review")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Automated Payment Transactions")
], -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Tenant Protection Summary")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "AI Agent")
], -1))
const _hoisted_15 = [
  _hoisted_14
]

import { ref, computed } from "vue";
import api from "@virgodev/bazaar/functions/api";
import BaseSpinner from "@/components/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert.vue";
import Filter from "@/components/Filter.vue";
import "@vueform/multiselect/themes/default.scss";
import { useStore } from "@/store/index";
import { watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const formSubmitting = ref(false);
const errors = ref("");
const status = ref("loading");
const client = ref();
const tppInfoVisible = ref(false);
const tppInfoMessage = ref("");
const aiAgentInfoVisible = ref(false);
const aiAgentInfoMessage = ref("");
const formFields = store.clientPortalFormFields;

const closeModal = () => {
  tppInfoVisible.value = false;
};

const closeAiAgentModal = () => {
  aiAgentInfoVisible.value = false;
};

const facilityOptions = ref(
  Array<{ label: string; value: string | null; disabled: boolean }>()
);

const dateOptions = ref([
  {
    text: "Current month",
    value: "current_month",
  },
  {
    text: "Last month",
    value: "last_month",
  },
  {
    text: "All year",
    value: "all_year",
  },
  {
    text: "Custom Dates",
    value: "custom",
  },
]);

watch(
  () => store.clientPortalFormFields.selected_facilities,
  () => {
    tppInfoVisible.value = false;
    aiAgentInfoVisible.value = false;
  }
);

const selectedNames = computed<string[]>(
  () => store.clientPortalFormFields.selected_facilities || []
);

// accommodate different backend flags; default to false
const hasTppForSelection = computed(() => {
  if (!client.value || !Array.isArray(client.value.facilities)) return false;
  if (!selectedNames.value.length) {
    // If no specific facilities selected, check if any facility has TPP
    return client.value.facilities.some(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (facility: any) => facility.show_tpp_on_client_portal
    );
  }
  // If specific facilities selected, check if any of them has TPP
  return selectedNames.value.some((name: string) => {
    const facility = client.value.facilities.find(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (f: any) => f.facility_name === name
    );
    return facility?.show_tpp_on_client_portal;
  });
});

const hasTalkdeskForSelection = computed(() => {
  if (!client.value || !Array.isArray(client.value.facilities)) return false;
  if (!selectedNames.value.length) {
    return client.value.facilities.some(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (facility: any) => facility.has_talkdesk_number
    );
  }
  return selectedNames.value.some((name: string) => {
    const facility = client.value.facilities.find(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (f: any) => f.facility_name === name
    );
    return facility?.has_talkdesk_number;
  });
});

async function getUserInfo() {
  status.value = "loading";
  errors.value = "";
  const response = await api({
    url: `client/`,
  });
  if (response.status == 200) {
    client.value = response.body[0];
    facilityOptions.value = [
      { label: "All Facilities", value: null, disabled: true },
    ];
    for (let facility of client.value.facilities) {
      facilityOptions.value.push({
        label: facility.facility_name,
        value: facility.facility_name,
        disabled: false,
      });
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  status.value = "loaded";
}

async function submitForm(payload: typeof formFields) {
  formSubmitting.value = true;
  errors.value = "";

  const res = await api({
    url: "client/facility_data/",
    method: "POST",
    json: payload,
  });

  if (res.status === 200) {
    // move on to TppSummary or Calls page after successful submission
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your connection and try again.";
  }

  formSubmitting.value = false;
}

function handleFilterSubmit(formData: typeof formFields) {
  store.setClientPortalFormFields(formData);
  submitForm(formData);
}
getUserInfo();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (errors.value)
      ? (_openBlock(), _createBlock(BaseAlert, {
          key: 0,
          variant: "danger",
          class: "js-form-error"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(errors.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 1,
          preset: "large"
        }))
      : _createCommentVNode("", true),
    (client.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, _toDisplayString(client.value.name), 1),
          _createElementVNode("div", null, [
            _createVNode(Filter, {
              "facility-options": facilityOptions.value,
              "date-options": dateOptions.value,
              "initial-form-fields": _unref(formFields),
              "form-submitting": formSubmitting.value,
              onSubmit: handleFilterSubmit
            }, null, 8, ["facility-options", "date-options", "initial-form-fields", "form-submitting"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                  (tppInfoVisible.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-backdrop tpp-info preserve-newlines",
                        role: "dialog",
                        "aria-modal": "true",
                        tabindex: "-1",
                        onClick: closeModal,
                        onKeydown: _withKeys(closeModal, ["esc"])
                      }, [
                        _createElementVNode("div", {
                          class: "modal-card",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createElementVNode("button", {
                            "aria-label": "Close",
                            class: "modal-close",
                            onClick: closeModal
                          }, " × "),
                          _hoisted_5,
                          _createElementVNode("p", null, _toDisplayString(tppInfoMessage.value), 1),
                          _createElementVNode("div", { class: "modal-actions" }, [
                            _createElementVNode("button", {
                              class: "btn btn-text",
                              onClick: closeModal
                            }, "OK")
                          ])
                        ])
                      ], 40, _hoisted_4))
                    : _createCommentVNode("", true)
                ])),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                  (aiAgentInfoVisible.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-backdrop tpp-info preserve-newlines",
                        role: "dialog",
                        "aria-modal": "true",
                        tabindex: "-1",
                        onClick: closeAiAgentModal,
                        onKeydown: _withKeys(closeAiAgentModal, ["esc"])
                      }, [
                        _createElementVNode("div", {
                          class: "modal-card",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createElementVNode("button", {
                            "aria-label": "Close",
                            class: "modal-close",
                            onClick: closeAiAgentModal
                          }, " × "),
                          _hoisted_7,
                          _createElementVNode("p", null, _toDisplayString(aiAgentInfoMessage.value), 1),
                          _createElementVNode("div", { class: "modal-actions" }, [
                            _createElementVNode("button", {
                              class: "btn btn-text",
                              onClick: closeAiAgentModal
                            }, " OK ")
                          ])
                        ])
                      ], 40, _hoisted_6))
                    : _createCommentVNode("", true)
                ])),
                _createVNode(_component_router_link, {
                  to: { name: 'CallsReview' },
                  "aria-label": "Go to Calls Review",
                  class: "box-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: { name: 'IvrPayments' },
                  "aria-label": "Go to Payment Transactions",
                  class: "box-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  custom: "",
                  to: { name: 'TppSummary' }
                }, {
                  default: _withCtx(({ navigate }) => [
                    _createElementVNode("a", {
                      href: "",
                      class: "box-link",
                      onClick: _withModifiers(($event: any) => (
                !_unref(hasTppForSelection)
                  ? ((tppInfoMessage.value =
                      'This facility is currently not enrolled in our TPP Program.\nFor more information give us a call at 801-750-9747'),
                    (tppInfoVisible.value = true))
                  : navigate()
              ), ["prevent"])
                    }, _hoisted_12, 8, _hoisted_10)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  custom: "",
                  to: { name: 'AiAgent' }
                }, {
                  default: _withCtx(({ navigate }) => [
                    _createElementVNode("a", {
                      href: "",
                      class: "box-link",
                      "aria-label": "Go to AI Agent",
                      onClick: _withModifiers(($event: any) => (
                !_unref(hasTalkdeskForSelection)
                  ? ((aiAgentInfoMessage.value =
                      'This facility is currently not enrolled in our AI Agent Program.\nFor more information give us a call at 801-750-9747'),
                    (aiAgentInfoVisible.value = true))
                  : navigate()
              ), ["prevent"])
                    }, _hoisted_15, 8, _hoisted_13)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})